import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import {
    IRegistrationFieldsConfig,
    IRegistrationFieldsConfigInput,
} from '../../entities/RegistrationFields/RegistrationFields.ts';

export class RegistrationFieldsApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/HealthcareFacilities`;

    public static apiUrls = {
        getByFacility: `${RegistrationFieldsApi.baseApiUrl}/:id/RegistrationFields`,
        save: `${RegistrationFieldsApi.baseApiUrl}/:id/RegistrationFields`,
    };

    public static async getByFacility(facilityId: number): Promise<IRegistrationFieldsConfig> {
        return this.sendApiRequest<IRegistrationFieldsConfig>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getByFacility,
            data: undefined,
            id: facilityId.toString(),
        });
    }

    public static async save(
        facilityId: number,
        config: IRegistrationFieldsConfigInput,
    ): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.save,
            data: config,
            id: facilityId.toString(),
        });
    }
}
